import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Action, State, StateContext } from '@ngxs/store';
import { AemModelClientService } from './aem-model-client.service';
import { AemGet, AemGetAppConfig, AemGetMaintenance, AemGetMessages } from './aem.action';
import { AemStateModel } from './aem.model';

@State<AemStateModel>({
  name: 'aem',
  defaults: {
    title: '',
    configuration: null,
    messages: null,
    mapping: null,
  },
})
@Injectable()
export class AemState {
  constructor(public aemClient: AemModelClientService, public route: ActivatedRoute) {
  }

  @Action(AemGet)
  async get({setState}: StateContext<AemStateModel>, {path}: any) {
    const response = await this.aemClient.fetch(path);

    setState(response);
  }

  @Action(AemGetMessages)
  async getMessages({setState, getState}: StateContext<AemStateModel>, {path}: any) {

  	const messages = await this.aemClient.fetch(path);

  	setState({...getState(), ...messages});
  }

  @Action(AemGetAppConfig)
  async getAppConfig({setState, getState}: StateContext<AemStateModel>, {path}: any) {

  	const appConfig = await this.aemClient.fetch(path);

  	setState({...getState(), ...appConfig});
  }

  @Action(AemGetMaintenance)
  async getMaintenance({setState, getState}: StateContext<AemStateModel>, {path}: any) {

  	const maintenance = await this.aemClient.fetch(path);

  	setState({...getState(), ...maintenance});
  }
}

